import MapChart from "./MapChart";

import "../src/App.css";
import "rsuite/dist/rsuite.min.css";
import "../src/tooltip.css";
import peopleData from "./data/people.json";

function App() {
  return (
    <div className="App">
      <nav>
        <div>
          <h1>The Godwin Group Sales Network</h1>
        </div>
      </nav>
      <MapChart />
      <div className="container" style={{ marginTop: "50px" }}>
        <h3 className="table-caption">Regional Sales Representatives</h3>
        <table className="salespeople-list">
          <thead>
            <tr>
              <th>Name</th>
              <th>Phone</th>
              <th>Email</th>
              <th>Region</th>
            </tr>
          </thead>
          <tbody>
            {peopleData.map((person) => (
              <tr key={person.name}>
                <td>{person.name}</td>
                <td>
                  <a href={`tel:${person.phone.replace(/\D/g, "")}`}>
                    {person.phone}
                  </a>
                </td>
                <td>
                  <a href={`mailto:${person.email}`}>{person.email}</a>
                </td>
                <td>
                  {person.region_name}{person.states?.length > 0 ? <><span>:</span></> : ""} {person.states?.join(", ")}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default App;
